module.exports = __webpack_public_path__ + "img/bn6.3765ffaa.jpg";